import { ServiceBase } from '../../../../core/services/ServiceBase'
import UserInfoProxy from '../proxies/UserManagementProxy'

class UserManagementService extends ServiceBase {
  getUserProfile(params) {
    return this.getData(() => UserInfoProxy.getUserProfile(params))
  }

  postUpdateUserProfileRequest(params) {
    return this.getData(
      () => UserInfoProxy.postUpdateUserProfileRequest(params),
      true,
    )
  }

  putUserProfile(params) {
    return this.getData(() => UserInfoProxy.putUserProfile(params), true)
  }

  getUserSetting(params) {
    return this.getData(() => UserInfoProxy.getUserSetting(params))
  }

  putUserSetting(params) {
    return this.getData(() => UserInfoProxy.putUserSetting(params), true)
  }

  getUserSettingWithPreference(params) {
    return this.getData(() =>
      UserInfoProxy.getUserSettingWithPreference(params),
    )
  }

  getSubscriptionPlans(params) {
    return this.getData(() => UserInfoProxy.getSubscriptionPlans(params))
  }

  getSubscriptionPlanDetails(params) {
    return this.getData(() => UserInfoProxy.getSubscriptionPlanDetails(params))
  }

  getPricingPackages(params) {
    return this.getData(() => UserInfoProxy.getPricingPackages(params))
  }

  postActiveTrial(params) {
    return this.getData(() => UserInfoProxy.postActiveTrial(params), true)
  }

  postDeactiveTrial(params) {
    return this.getData(() => UserInfoProxy.postDeactiveTrial(params), true)
  }

  getUserPricingPackagesPaged(params) {
    return this.getData(() => UserInfoProxy.getUserPricingPackagesPaged(params))
  }

  getSampleQuotations(params) {
    return this.getFileDownload(() => UserInfoProxy.getSampleQuotations(params))
  }

  postQuotations(params) {
    return this.getFileDownload(
      () => UserInfoProxy.postQuotations(params),
      true,
    )
  }

  getSampleContract(params) {
    return this.getFileDownload(() => UserInfoProxy.getSampleContract(params))
  }

  postRequest(params) {
    return this.getData(() => UserInfoProxy.postRequest(params), true)
  }

  postOrders(params) {
    return this.getData(() => UserInfoProxy.postOrders(params), true)
  }

  getSubscriptionPricings(params) {
    return this.getData(() => UserInfoProxy.getSubscriptionPricings(params))
  }

  postSubscriptionAndPackageOrders(params) {
    return this.getData(
      () => UserInfoProxy.postSubscriptionAndPackageOrders(params),
      true,
    )
  }

  getSubscriptionAndPackageOrdersPaged(params) {
    return this.getData(() =>
      UserInfoProxy.getSubscriptionAndPackageOrdersPaged(params),
    )
  }

  getSubscriptionAndPackageOrdersTypes(params) {
    return this.getData(() =>
      UserInfoProxy.getSubscriptionAndPackageOrdersTypes(params),
    )
  }

  postSubscriptionAndPackageNewTransaction(params) {
    return this.getData(
      () => UserInfoProxy.postSubscriptionAndPackageNewTransaction(params),
      true,
    )
  }

  getSubscriptionAndPackageOrdersById(params) {
    return this.getData(() =>
      UserInfoProxy.getSubscriptionAndPackageOrdersById(params),
    )
  }

  getDetailRequestContract(params) {
    return this.getFileDownload(() =>
      UserInfoProxy.getDetailRequestContract(params),
    )
  }

  getDetailRequestConfirmation(params) {
    return this.getFileDownload(() =>
      UserInfoProxy.getDetailRequestConfirmation(params),
    )
  }

  getEngagementHistoryTypes(params) {
    return this.getData(() => UserInfoProxy.getEngagementHistoryTypes(params))
  }

  getEngagementHistoryPaged(params) {
    return this.getData(() => UserInfoProxy.getEngagementHistoryPaged(params))
  }

  getUserProfileFields(params) {
    return this.getData(() => UserInfoProxy.getUserProfileFields(params))
  }

  getIsAvailableToAddNewSubscription(params) {
    return this.getData(() =>
      UserInfoProxy.getIsAvailableToAddNewSubscription(params),
    )
  }

  postCancelRequestOrder(params) {
    return this.getData(
      () => UserInfoProxy.postCancelRequestOrder(params),
      true,
    )
  }

  getSNPNewTransactionPreview(params) {
    return this.getData(() => UserInfoProxy.getSNPNewTransactionPreview(params))
  }

  putUserSettingAlternative(params) {
    return this.getData(
      () => UserInfoProxy.putUserSettingAlternative(params),
      true,
    )
  }
}

export default new UserManagementService()
